import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88848370"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title", "aria-label", "aria-expanded"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "icon-container",
    title: _ctx.toggleLabel,
    "aria-label": _ctx.toggleLabel,
    "aria-expanded": _ctx.opened,
    "aria-keyshortcuts": "Alt+T",
    role: "button",
    tabindex: "0",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.iconclick && _ctx.iconclick(...args))),
    onKeydown: [
      _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.iconclick && _ctx.iconclick(...args)), ["prevent"]), ["enter"])),
      _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.iconclick && _ctx.iconclick(...args)), ["prevent"]), ["space"]))
    ]
  }, [
    _createVNode(_component_svg_icon, { icon: _ctx.icon }, null, 8, ["icon"])
  ], 40, _hoisted_1))
}